import { Suspense } from "react"
import OrganizationPage from "@/components/organization"
import OrganizationSkeleton from "@/components/organization-skeleton"

export default function HomePage() {
  return (
    <Suspense fallback={<OrganizationSkeleton />}>
      <OrganizationPage />
    </Suspense>
  )
}
